import LandingHeader from "../components/landing/LandingHeader"
import FaqCategoriesSection from "../components/landing/FaqCategoriesSection"
import FaqAccordion from "../components/landing/FaqAccordion"
import Footer from "../components/ui/Footer"
import { faqCategories, generalFaq } from "../data/faq"
import { useSiteContent } from "../hooks/useSiteContent"
import EditableText from "../components/ui/EditableText"

export default function FaqPage() {
  const site = useSiteContent("faq")

  const categories = faqCategories.map((category) => ({
    title: site.get(`faq.category.${category.key}.title`, category.title),
    image: category.image,
    path: `/faq/${category.key}`,
    summary: site.get(`faq.category.${category.key}.summary`, category.summary),
  }))

  const generalItems = generalFaq.map((item, index) => ({
    question: site.get(`faq.general.item.${index}.question`, item.question),
    answer: site.get(`faq.general.item.${index}.answer`, item.answer),
  }))

  return (
    <div className="flex min-h-screen flex-col">
      {site.isAdmin && (
        <button
          type="button"
          onClick={() => site.setEditMode(!site.editMode)}
          className={`fixed bottom-6 right-6 z-50 rounded-full border-2 border-white px-5 py-3 text-sm font-semibold shadow-xl transition ${
            site.editMode ? "bg-orange-500 text-white" : "bg-dantzBlue text-white"
          }`}
        >
          {site.editMode ? "Done editing" : "Edit page"}
        </button>
      )}

      <section
        className="relative overflow-hidden bg-dantzBlue bg-cover bg-center px-4 pb-16 pt-6 md:px-6"
        style={{ backgroundImage: "url('/images/instant-filing-bg.svg')" }}
      >
        <div className="absolute inset-0 bg-dantzBlue/80" />

        <LandingHeader />

        <div className="relative z-10 mx-auto mt-8 h-px w-full max-w-6xl bg-white/70" />

        <div className="relative z-10 mx-auto mt-12 max-w-3xl text-center text-white">
          <EditableText
            as="h1"
            value={site.get("faq.hero.heading", "HOW CAN WE HELP?")}
            editMode={site.editMode}
            onSave={(value) => site.save("faq.hero.heading", value)}
            className="block text-[36px] font-normal tracking-widest md:text-[40px]"
          />
          <EditableText
            as="p"
            value={site.get(
              "faq.hero.description",
              "xpress-ip makes European patent, trademark and design filing simple. Choose the type of European IP protection you are interested in, or see the general questions below."
            )}
            editMode={site.editMode}
            multiline
            onSave={(value) => site.save("faq.hero.description", value)}
            className="mt-4 block text-sm font-light leading-relaxed text-slate-200"
          />
        </div>

        <FaqCategoriesSection
          categories={categories}
          editable={site.editMode}
          onSaveTitle={(index, value) =>
            site.save(`faq.category.${faqCategories[index].key}.title`, value)
          }
          onSaveSummary={(index, value) =>
            site.save(`faq.category.${faqCategories[index].key}.summary`, value)
          }
        />
      </section>

      <section className="bg-white px-4 py-16 md:px-8">
        <div className="mx-auto max-w-4xl text-dantzBlue">
          <div className="mx-auto w-11/12 border-t border-dantzBlue" />

          <EditableText
            as="h2"
            value={site.get("faq.general.heading", "GENERAL")}
            editMode={site.editMode}
            onSave={(value) => site.save("faq.general.heading", value)}
            className="mt-12 block text-center text-[26px] font-light tracking-widest"
          />

          <FaqAccordion
            items={generalItems}
            editable={site.editMode}
            onSaveQuestion={(index, value) =>
              site.save(`faq.general.item.${index}.question`, value)
            }
            onSaveAnswer={(index, value) =>
              site.save(`faq.general.item.${index}.answer`, value)
            }
          />
        </div>
      </section>

      <Footer
        editable={site.editMode}
        email={site.get("faq.footer.email", "info@xpress-ip.com")}
        tagline={site.get("faq.footer.tagline", "EUROPEAN IP FILING, MADE SIMPLE.")}
        taglineSub={site.get("faq.footer.taglineSub", "Patents · Trademarks · Designs")}
        onSaveEmail={(value) => site.save("faq.footer.email", value)}
        onSaveTagline={(value) => site.save("faq.footer.tagline", value)}
        onSaveTaglineSub={(value) => site.save("faq.footer.taglineSub", value)}
      />
    </div>
  )
}
